export enum TAG_MANAGER_EVENTS {
  CHOOSE_SUBSCRIPTION_ONBOARDING = 'choose_subscription_onboarding',
  PURCHASE_COMPLETE_ONBOARDING = 'purchase_complete_onboarding',
}
